import { useSelector } from "react-redux";
import { getRouterState } from "../../redux/rootReducer";
import * as React from "react";
import { useEffect } from "react";
import io from "../../redux/io";
import { getGcpRequestAppLink } from "../../utils/getGcpRequestAppLink";
import { style } from "typestyle";

export const RedirectToGcpRequestApp = () => {
  const routerState = useSelector(getRouterState);
  const { customerId, siteId } = routerState.data;

  useEffect(() => {
    io.changeLocation(getGcpRequestAppLink(customerId, siteId));
  }, []);

  return (
    <div className={style({ padding: 10 })}>
      You are being redirected to the GCP Request App...
    </div>
  );
};
